import { render, staticRenderFns } from "./IDEdit.vue?vue&type=template&id=520206a4"
import script from "./IDEdit.vue?vue&type=script&lang=js"
export * from "./IDEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports